import React from "react";
import { useForm } from "react-hook-form";
import { PageTitleProps, TitleForm } from "./PageTitle.types";

export function usePageTitle(props: PageTitleProps) {
  const {
    onTitleEdit,
    onTitleSave,
    onTitleCancel,
    subTitle,
    title,
    titleEditLabel,
    titleEditable,
    titleEditing,
    titleMaxLength,
    titleSaving,
    titleEditDisabled,
    titleEditDisabledTooltip,
    titleSize = "big",
  } = props;

  const form = useForm<TitleForm>();

  const { reset } = form;

  const saveTitle = (values: TitleForm) => {
    onTitleSave?.(values.name);
  };

  const titleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Escape") {
      reset({ name: title });
      onTitleCancel?.();
    }
  };

  const cancelEdit = () => {
    reset({ name: title });
    onTitleCancel?.();
  };

  React.useEffect(() => {
    reset({ name: title });
  }, [reset, title]);

  return {
    ...props,
    cancelEdit,
    form,
    onTitleEdit,
    saveTitle,
    subTitle,
    title,
    titleEditDisabled,
    titleEditDisabledTooltip,
    titleEditLabel,
    titleEditable,
    titleEditing,
    titleMaxLength,
    titleSaving,
    titleKeyDown,
    titleSize,
  };
}
